import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// shadcn's class merge helper: clsx resolves conditionals, tailwind-merge dedupes conflicting
// Tailwind utilities (the last wins). Used by shadcn/ui components and any of ours that compose
// class lists.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
